/* Core / critical JS only - loaded on every page for rendering priority elements */
/* Keep it as small as possible! */

/* global gsap */

function CookiebotCallback_OnAccept() {
    Cookiebot.changed && document.location.reload();
}

document.addEventListener("DOMContentLoaded", function (event) {

    // const mobileNavMenu = document.getElementById("mobile-nav-menu");
    // const stickyNav = document.getElementById("sticky-nav");
    // const navOverlay = document.getElementById("mobile-nav-background-overlay");
    // const mainMobileMenu = document.getElementById("mobile-nav-menu-links");
    // const mobileNavBottomLine = document.getElementById("mobile-nav-bottom-line");
    // const mobileNavCredit = document.getElementById("mobile-nav-bottom-credit");
    // let menuToggleTl = gsap.timeline();
    //
    // const openNavMenu = () => {
    //
    //     // Open menu
    //     mobileNavMenu.classList.add("active");
    //     menuToggleTl
    //         .to(navOverlay, {right: "0", duration: 0})
    //         .to(navOverlay, {opacity: "0.4", duration: 0})
    //         // .to(stickyNav, {opacity: 0, duration: 0.1})
    //         .to(mobileNavMenu, {right: "0"}, "<");
    // }
    //
    // const openMenuButton = document.getElementById("open-menu-button");
    // openMenuButton.addEventListener('click', openNavMenu, false);
    //
    // const mobileMenuSubNavLinks = document.getElementsByClassName("mobile-nav-menu-sub-links");
    //
    // const closeNavMenu = () => {
    //     let calculateWidth = mobileNavMenu.offsetWidth;
    //     // Close menu
    //     mobileNavMenu.classList.remove("active");
    //     menuToggleTl
    //         .to(navOverlay, {opacity: "0", duration: 0})
    //         .to(navOverlay, {right: "-100vw", duration: 0})
    //         .to(mobileNavMenu, {right: calculateWidth * -1}, "<")
    //         // .to(stickyNav, {opacity: 1, duration: 0.1});
    //     mainMobileMenu.classList.remove("mobile-nav-menu-links-hide");
    //     for (let x = 0; x < mobileMenuSubNavLinks.length; x++) {
    //         mobileMenuSubNavLinks[x].classList.remove('mobile-nav-menu-sub-links-show');
    //     }
    // }
    //
    // const closeMenuButton = document.getElementById("close-menu-button");
    // closeMenuButton.addEventListener('click', closeNavMenu, false);
    //
    // const mobileNavArrows = document.getElementsByClassName("mobile-nav-menu-links-item-arrow");
    //
    // for (let i = 0; i < mobileNavArrows.length; i++) {
    //     mobileNavArrows[i].addEventListener('click', event => {
    //         let menuID = event.currentTarget.getAttribute('data-menu-id');
    //         mainMobileMenu.classList.add("mobile-nav-menu-links-hide");
    //         let subMenu = document.getElementById("mobile-nav-menu-sub-links-" + menuID);
    //         subMenu.classList.add("mobile-nav-menu-sub-links-show");
    //         // mobileNavCredit.classList.add("d-none");
    //         mobileNavBottomLine.classList.add("d-block");
    //     });
    // }
    //
    // const mobileNavCloseArrows = document.getElementsByClassName("mobile-nav-menu-links-item-back-arrow");
    //
    // for (let y = 0; y < mobileNavCloseArrows.length; y++) {
    //     mobileNavCloseArrows[y].addEventListener('click', event => {
    //         mainMobileMenu.classList.remove("mobile-nav-menu-links-hide");
    //         for (let x = 0; x < mobileMenuSubNavLinks.length; x++) {
    //             mobileMenuSubNavLinks[x].classList.remove('mobile-nav-menu-sub-links-show');
    //         }
    //         mobileNavBottomLine.classList.remove("d-block");
    //         // mobileNavCredit.classList.remove("d-none");
    //     });
    // }

    const closeBannerButton = document.getElementById("site-banner-close");

    if (closeBannerButton !== null) {
        const closeBanner = () => {
            const siteBanner = document.getElementById("site-banner");
            siteBanner.classList.add('site-banner-offscreen')
        }

        closeBannerButton.addEventListener('click', closeBanner, false);
    }

    let lastScrollTop = 0;
    const navigation = document.getElementById("navigation");

    window.addEventListener("scroll", function () {
        let st = window.pageYOffset || document.documentElement.scrollTop;

        if (st === 0) {
            navigation.classList.remove('scrolling');
            navigation.classList.add('nav-at-top');
        } else {
            navigation.classList.remove('nav-at-top');
        }

        if (st > lastScrollTop) {
            // downscroll code
            navigation.classList.add('scrolling');
        } else {
            // upscroll code
            navigation.classList.remove('scrolling');
        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }, false);

    window.dispatchEvent(new CustomEvent('scroll'));
});





